import classNames from "classnames";

interface IProps {
  theme?: "light" | "dark";
  style?: string;
  onClick?: () => void;
  color?: string;
}

export const ArrowDownIcon = ({ color, style, theme, onClick }: IProps) => {
  return (
    <div
      className={classNames({
        "arrow-down-icon-container": true,
        [`${style}`]: style,
      })}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="12"
        viewBox="0 0 20 12"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2788 11.2978C20.2151 10.3649 20.2177 8.8497 19.2848 7.91348L12.1183 0.721439C11.1854 -0.214782 9.67015 -0.217471 8.73393 0.715434L1.54189 7.882C0.605667 8.8149 0.602978 10.3301 1.53588 11.2663C2.46879 12.2026 3.98402 12.2053 4.92024 11.2724L10.4171 5.79497L15.8945 11.2918C16.8274 12.2281 18.3426 12.2307 19.2788 11.2978Z"
          fill={color ? color : theme === "light" ? "black" : "white"}
        />
      </svg>
    </div>
  );
};
